import {
  CLEAN_DETAIL_TRANSACTIONS_MERCADOPAGO,
  CLEAN_DETAIL_TRANSACTIONS_MERCADOPAGO_ERROR,
} from '_models/redux/types';

export const cleanDetailMercadoPagoAction = () => async (dispatch) => {
  try {
    dispatch({
      payload: undefined,
      type: CLEAN_DETAIL_TRANSACTIONS_MERCADOPAGO,
    });
  } catch {
    dispatch({
      payload: undefined,
      type: CLEAN_DETAIL_TRANSACTIONS_MERCADOPAGO_ERROR,
    });
  }
};
